import createModel, { prop } from '../lib/create_model';

export default createModel({
  modelName: 'FbMessengerUserId',
  properties: {
    pageId: prop(String).isRequired,
    userId: prop(String).isRequired, // page-specific user id, PSID
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/customer_profile/fb_messenger_user_id.js